import React from 'react';
import { Link } from 'react-router-dom';

import BookList from 'rebook/apps/books/components/BookList';
import pluralize from 'rebook/apps/utils/text/pluralize';

import styles from './style.scss';


const SearchBooklist = ({ bookList, booksCount, query }) => {
  const maxAmount = 8;

  return (
    <div className={styles.section}>
      <div className="title-1">Книги</div>
      {booksCount > maxAmount && (
        <Link className="cy-search-all-books"
          to={{
            pathname: `/search/books/`,
            state: { bookList, booksCount, query },
            search: `?q=${query}` }}>
          <div className="link">
            {booksCount} {pluralize(booksCount, 'книга', 'книги', 'книг')}
          </div>
        </Link>
      )}
      <div className={styles.content}>
        <BookList books={bookList.length > maxAmount ? bookList.slice(0, maxAmount) : bookList} />
      </div>
    </div>
  );
};

export default SearchBooklist;
